import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import {
  buildOfferAnalyticsBaseParams,
  OFFER_PAY_PROVIDER,
} from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
  productId: string;
  cValue: number;
  ltvPred: number;
  transactionId: string;
}

export const trackOfferSaleSuccess = ({
  offerKey,
  productId,
  cValue,
  ltvPred,
  transactionId,
}: Params) =>
  track({
    event: "sale_scs",
    ...buildOfferAnalyticsBaseParams(offerKey),
    pay_provider: OFFER_PAY_PROVIDER,
    subs_id: productId,
    product_id: productId,
    c_value: cValue,
    ltv_pred: ltvPred,
    transaction_id: transactionId,
  });
